var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{ref:"ToolCode",staticClass:"ToolCode",class:{ 'ToolCode--autoSize': _vm.autoSize },attrs:{"value":_vm.value,"options":_vm.optionsWithDefaults},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }